import React from 'react';
import { IconProps } from '../../Types';

export const IconBackGroundClientReviewTopRight = (props: IconProps) => {
    return (
        <svg width='487' height='368' viewBox='0 0 487 368' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
            <circle cx='367.222' cy='-41.3896' r='208.562' transform='rotate(148.908 367.222 -41.3896)' fill='#D1E0FF'/>
            <circle opacity='0.5' cx='361.423' cy='6.42557' r='263.095' transform='rotate(148.908 361.423 6.42557)' fill='#D1E0FF'/>
        </svg>
    );
};

